export const patientStatesConfigs = [
  { key: 'preEnrolled', apiKey: 'pre_enrolled', copy: 'patient_state_pre_enrolled' },
  { key: 'enrolled', apiKey: 'enrolled', copy: 'patient_state_enrolled' },
  { key: 'active', apiKey: 'active', copy: 'patient_state_active' },
  { key: 'treated', apiKey: 'treated', copy: 'patient_state_treated' },
  { key: 'maintenance', apiKey: 'maintenance', copy: 'patient_state_maintenance' },
  { key: 'excluded', apiKey: 'excluded', copy: 'patient_state_excluded' },
  { key: 'dropout', apiKey: 'dropout', copy: 'patient_state_dropout' },
  { key: 'inactive', apiKey: 'inactive', copy: 'patient_state_inactive' },
  { key: 'closed', apiKey: 'closed', copy: 'patient_state_closed' },
  { key: 'discharged', apiKey: 'discharged', copy: 'patient_state_discharged' },
]

export const stateKeyDecoder = {
  apiToClient: (apiKey) => {
    const decodedKey = patientStatesConfigs.find((psc) => psc.apiKey === apiKey)

    return decodedKey ? decodedKey.key : undefined
  },
  clientToApi: (clientKey) => {
    const decodedKey = patientStatesConfigs.find((psc) => psc.key === clientKey)

    return decodedKey ? decodedKey.apiKey : undefined
  },
}

const defaultExclusionJustifications = [
  {
    optLabel: 'exclusion_reason_clinical_condition_related_requires_in_person_pt',
    optValue: 'exclusion_reason_clinical_condition_related_requires_in_person_pt',
  },
  {
    optLabel: 'exclusion_reason_clinical_condition_related_requires_care_escalation',
    optValue: 'exclusion_reason_clinical_condition_related_requires_care_escalation',
  },
  {
    optLabel: 'exclusion_reason_clinical_non_condition_related_requires_other_healthcare_provider',
    optValue: 'exclusion_reason_clinical_non_condition_related_requires_other_healthcare_provider',
  },
  {
    optLabel: 'exclusion_reason_clinical_non_condition_related_non_msk_complaints',
    optValue: 'exclusion_reason_clinical_non_condition_related_non_msk_complaints',
  },
  {
    optLabel: 'exclusion_reason_clinical_referral_denied',
    optValue: 'exclusion_reason_clinical_referral_denied',
  },
  {
    optLabel: 'exclusion_reason.clinical_change_program',
    optValue: 'exclusion_reason_clinical_change_program',
  },
  {
    optLabel: 'exclusion_reason_clinical_other',
    optValue: 'exclusion_reason_clinical_other',
  },
  {
    optLabel: 'exclusion_reason_non_clinical_loss_coverage',
    optValue: 'exclusion_reason_non_clinical_loss_coverage',
  },
  {
    optLabel: 'exclusion_reason_non_clinical_other',
    optValue: 'exclusion_reason_non_clinical_other',
  },
  {
    optLabel: 'exclusion_reason.on_hold_clinical_personal_health',
    optValue: 'exclusion_reason_on_hold_clinical_personal_health',
  },
  {
    optLabel: 'exclusion_reason.on_hold_non_clinical_personal_reason',
    optValue: 'exclusion_reason_on_hold_non_clinical_personal_reason',
  },
  {
    optLabel: 'exclusion_reason.on_hold_non_clinical_vacations',
    optValue: 'exclusion_reason_on_hold_non_clinical_vacations',
  },
  {
    optLabel: 'exclusion_reason.on_hold_non_clinical_other',
    optValue: 'exclusion_reason_on_hold_non_clinical_other',
  },
]

const exclusionJustificationsActive = defaultExclusionJustifications.map((item) => {
  if (item.optLabel === 'exclusion_reason.on_hold_clinical_personal_health') {
    item.optValue = 'on_hold_clinical_personal_health'
  }

  return item
})

export const patientStateChangeConfigs = {
  deactivationOptions: {
    reasons: [
      { optLabel: 'copy_3681', optValue: 'maintenance', color: 'green' },
      { optLabel: 'copy_3682', optValue: 'dropout', color: 'red' },
      { optLabel: 'copy_3683', optValue: 'excluded', color: 'yellow' },
      { optLabel: 'closed', optValue: 'closed', color: 'red' },
    ],
    justifications: {
      dropout: {
        pre_enrolled: [
          { optLabel: 'copy_3686', optValue: 'dropout_conventional_PT' },
          { optLabel: 'copy_3688', optValue: 'dropout_low_tech_literacy' },
          { optLabel: 'copy_3689', optValue: 'dropout_low_compliance' },
          { optLabel: 'copy_1026', optValue: 'dropout_other' },
        ],
        enrolled: [
          { optLabel: 'copy_3686', optValue: 'dropout_conventional_PT' },
          { optLabel: 'copy_3688', optValue: 'dropout_low_tech_literacy' },
          { optLabel: 'copy_3689', optValue: 'dropout_low_compliance' },
          { optLabel: 'copy_1026', optValue: 'dropout_other' },
        ],
        active: [
          { optLabel: 'copy_3686', optValue: 'dropout_conventional_PT' },
          { optLabel: 'copy_3688', optValue: 'dropout_low_tech_literacy' },
          { optLabel: 'copy_3689', optValue: 'dropout_low_compliance' },
          { optLabel: 'copy_1026', optValue: 'dropout_other' },
        ],
      },
      excluded: {
        enrolled: defaultExclusionJustifications,
        active: exclusionJustificationsActive,
        on_hold: exclusionJustificationsActive,
      },
    },
    justificationLabels: {
      dropout: 'copy_3685',
      excluded: 'copy_3695',
    },
  },
}
